import { useEffect, useState } from 'react';

import { useCrossProductTransitionUrl } from './useCrossProductTransitionUrl';

/**
 * Hook that transforms a SeekPass URL for cross-product SSO.
 *
 * @param url - The original SeekPass URL to transform
 * @returns The transformed URL
 */
export const useSeekPassUrl = (url: string): string => {
  const transformUrl = useCrossProductTransitionUrl('seekpass');
  const [transformedUrl, setTransformedUrl] = useState(url);

  useEffect(() => {
    const transform = async () => {
      const transformed = await transformUrl(url);
      setTransformedUrl(transformed);
    };

    transform();
  }, [url, transformUrl]);

  return transformedUrl;
};
